import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { bancoApi } from 'app/services/api/bancoApi';
import React from 'react';

const SelectBanco = ({ id, name, label, value, touched, error, onBlur, onChange, required = false }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(banco) => {
        return banco?.id;
      }}
      getOptionLabel={(banco) => {
        return `${banco.codigo ? `${banco.codigo} - ` : ''}${banco.nome}`;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }
        const response = await bancoApi.pesquisarPorNomeECodigo({
          size: 100,
          sort: 'codigo',
          page: next,
          q: query,
        });

        const links = parseHeaderForLinks(response.headers.link);
        const totalItems = response.headers['x-total-count'];
        const data = response?.data || [];

        return { data, nextPage: links.next, totalItems };
      }}
      fetchOnFocus
      required={required}
    />
  );
};

export default SelectBanco;
